export default __webpack_public_path__ + "static/media/ujmd.416183f0.png";